<script>
// コンポーネントと認識させるためにexport default は必要
export default {

}
</script>

<style lang="scss">
  @mixin bodyHeight($fixHeight: 0px) {
    height: calc(100vh - 86px - #{$fixHeight});
    overflow-y: scroll;
  }
  @mixin smallView($text, $isReverse: 'normal') {
    width: 60px;
    overflow: hidden;
    position: relative;
    &::before {
      // display: flex;
      // align-items: center;
      display: block;
      content: $text;
      font-size: 14px;
      width: 25px;
      text-align: center;
      padding-bottom: 37px;
      @if $isReverse == 'reverse' {
        background-image: url('data:img/png;base64,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');
      } @else {
        background-image: url('data:image/png;base64,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');
      }
      background-size: 100%;
      background-position: center bottom;
      position: absolute;
      left: 0;
      top: 36.58%;
      right: 0;
      margin: auto;
      color: #707070;
    }
    // &::after {
    //   content: "";
    //   display: block;
    //   width: 25px;
    //   height: 25px;
      
    //   background-position: center;
    //   position: absolute;
    //   top: 43.2%;
    //   left: 0;
    //   right: 0;
    //   margin: auto;
    // }
  }
  .document-formbox {
    &.upper {
      position: relative;
      z-index: 2;
    }
  }
  .document-wrap {
    width: 100%;
    .box02.white {
      width: 100%;
    }
  }
  .document-column {
    display: flex;
    align-items: stretch;
    justify-content: center;
    height: 100%;
    &-item {
      width: 50%;
      transition: width .2s ease;
      //overflow-y: scroll;
      & + & {
        border-left: 1px solid #DDDDDD;
      }
      &.is-hidden {
        display: none;
      }
      &.is-full {
        width: 100%;
      }
      &.list {
        &.is-small {
          @include smallView('目次');
          & > * {
            display: none;
          }
        }
      }
      &.listResult {
        &.is-small {
          @include smallView('要旨一覧', 'reverse');
          & > * {
            display: none;
          }
        }
        .document-result-body {
          @include bodyHeight(78px);
        }
      }
      &.searchResult {
        &.is-small {
          @include smallView('検索結果', 'reverse');
          & > * {
            display: none;
          }
        }
        .document-result-body {
          @include bodyHeight(78px);
        }
      }
      &.form {
        &.is-small {
          @include smallView('検索');
          & > * {
            display: none;
          }
        }
      }
    }
  }
  .document-lists {
    &-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 30px;
      min-height: 78px;
      &-text {
        font-size: 12px;
        color: #999999;
        text-decoration: underline;
        & + & {
          margin-left: 45px;
        }
      }
      &-icon {
        width: 24px;
        height: 24px;
        color: $color-link;
        position: relative;
        .tip {
          position: absolute;
          top: -20px;
          //margin-left: 4px;
          left: 50%;
          transform: translate3d(-50%,0,0);
          font-size: 1.4rem;
          font-weight: normal;
          white-space: nowrap;
          opacity: 0;
          transition: opacity .2s;
        }
        &:hover {
          -webkit-box-shadow: 0 5px 20px rgb(0 0 0 / 16%);
          box-shadow: 0 5px 20px rgb(0 0 0 / 16%);
          .tip {
            opacity: 1;
          }
        }
        .icn {
          width: 16px;
          height: 16px;
        }
        & + & {
          margin-left: 25px;
        }
      }
    }
    &-body {
      padding: 16px 0 20px 30px;
      @include bodyHeight(78px);
      //margin-top: 36px;
      font-size: 18px;
      line-height: 1.2;
      overflow-y: scroll;
      color: #707070;
      & + .document-lists-accordion {
        margin-top: 12px;
      }
    }
    &-accordion {
      .document-lists-accordion {
        padding-left: 1em;
      }
      &-head {
        display: block;
        margin-top: 16px;
        padding-left: 1em;
        padding-right: 30px;
        font-size: 14px;
        position: relative;
        cursor: pointer;
        text-align: left;
        &::before,
        &::after {
          content: "";
          display: block;
          width: 0.8em;
          height: 1px;
          background: currentColor;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
        &::after {
          transform: rotate(90deg);
        }
        &.is-open {
          &::after {
            display: none;
          }
          & + .document-lists-accordion-body {
            height: auto;
          }
        }
      }
      &-body {
        display: block;
        height: 0;
        overflow: hidden;
        margin-top: 8px;
      }
      &-item {
        display: block;
        text-indent: -1em;
        padding: 8px 30px 8px 2em;
        color: #0081BB;
        font-size: 14px;
        cursor: pointer;
        &.is-current {
          background-color: #D4E7F4;
        }
      }
    }
  }
  @media print{
    .document-lists-accordion-head {
      &::after {
        display: none;
      }
      & + .document-lists-accordion-body {
        height: auto;
      }
    }
  }
  .document-summary {
    padding: 35px 30px;
    &-title {
      font-size: 32px;
      font-weight: bold;
    }
    &-text {
      margin-top: 30px;
      font-size: 14px;
      color: #707070;
      line-height: 1.214;
      a{
        color: #005BAC;
        &:hover{
          opacity: 0.7;
          text-decoration: underline;
        }
      }
      & + .document-summary-text{
        margin-top: 15px;
      }
    }
  }
  .document-result {
    &-title {
      font-size: 16px;
      color: #707070;
      padding: 27px 23px;
      border-bottom: 1px solid #DDDDDD;
      strong {
        display: inline-block;
        font-size: 18px;
        line-height: 1;
        & + small {
          margin-left: 12px;
        }
      }
      small {
        display: inline-block;
        font-size: 12px;
      }
    }
    &-column {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      padding: 0 23px;
      border-bottom: 1px solid #DDDDDD;
      .document-result-title {
        padding: 27px 0;
        border-bottom: none;
      }
    }
    &-buttons {
      display: flex;
      align-items: stretch;
      justify-content: flex-end;
      button {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 27px 0;
        color: #005BAC;
        font-size: 12px;
        & + button {
          margin-left: 16px;
          padding-left: 16px;
          position: relative;
          &::before {
            content: "";
            display: block;
            width: 1px;
            height: 51.28%;
            background-color: #E4E4E4;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            margin: auto;
          }
        }
      }
    }
    &-body {
      padding: 30px 0;
    }
  }
  .document-search {
    &-title {
      font-size: 16px;
      color: #333;
      padding: 27px 23px;
      border-bottom: 1px solid #DDDDDD;
    }
    &-body {
      padding: 8px 23px 23px;
      @include bodyHeight(79px);
    }
    .formparts {
      &.right {
        display: flex;
        justify-content: flex-end;
      }
      &.select {
        // z-index: 10;
      }
      &.radio{
        z-index: 0;
      }
    }
    &-formparts {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 14px;
      margin-bottom: -14px;
      &-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 14px;
        & > * {
          & + * {
            margin-top: 0 !important;
            margin-left: 20px;
          }
        }
      }
      &.right {
        justify-content: flex-end;
      }
    }
  }
  .document-formbox{
    &.small {
      max-width: 168px;
    }
    .formparts.select {
      .select-option {
        .select-option-list {
          li {
            label {
              text-align: left;
            }
          }
        }
      }
    }
    &-title {
      margin: 20px 0 8px;
      font-weight: bold;
      font-size: 14px;
    }
    &.num{
      .document-formbox-content{
        &.wrap {
          flex-wrap: wrap;
          .formparts{
            margin-bottom: 8px;
          }
        }
        .formparts{
          &.select{
            flex-basis: 168px;
            &.long{
              flex-basis: 355px;
              flex-shrink: 0;
            }
            &.full {
              flex-basis: 100%;
            }
          }
          &.text{
            input{
              text-align: right;
            }
            &.long{
              flex-basis: 84px;
            }
            &.short{
              flex-basis: 55px;
            }
            &.full {
              flex-basis: 336px;
              input {
                text-align: left;
              }
            }
            &.max {
              flex-basis: 100%;
              input {
                text-align: left;
              }
            }
          }
          & + span{
            margin-left: 5px;
          }
        }
        span{
          & + .formparts{
            margin-left: 5px;
          }
        }
      }
    }
    &.year{
      .document-formbox-content{
        align-items: flex-end;
        .formparts{
          &.select{
            flex-basis: 102px;
          }
          & + .formparts{
            margin: 0 0 0 5px;
          }
          &.text{
            input{
              text-align: right;
            }
            &.long{
              flex-basis: 102px;
            }
            &.short{
              flex-basis: 53px;
            }
          }
          & + span{
            margin-left: 5px;
          }
        }
        span{
          & + .formparts{
            margin-left: 5px;
          }
        }
      }
    }
    &.info{
      .document-formbox-content{
        .formparts{
          &.select{
            flex-basis: 114px;
          }
          & + .formparts{
            margin: 0 0 0 5px;
          }
        }
      }
    }
    &.submit{
      margin-top: 44px;
      text-align: center;
      .button{
        button{
          width: 211px;
          display: inline-block;
          background: #1F81D8;
          color: #fff;
          border-radius: 5px;
          border: none;
        }
      }
      .document-formbox-clear{
        color: #1F81D8;
        font-size: 12px;
        display: inline-block;
        margin-top: 15px;
      }
    }
    &.calendar{
      .document-formbox-dateinput{
        border: 4px solid #F0F0F0;
        outline: 1px solid #DDDDDD;
        outline-offset: -4px;
        background-color: #fff;
        border-radius: 5px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-right: 8px;
        flex-basis: 168px;
        input{
          &[type="text"]{
            height: 40px;
            padding: 8px 15px;
          }
          &[type="date"]{
            &::-webkit-datetime-edit{
              display: none;
            }
          }
        }
        & + span{
          margin: 0 5px;
        }
      }
    }
    &-content{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      margin-top: 10px;
    }
  }
  .document-pager {
    display: flex;
    align-items: center;
    justify-content: center;
    &-list {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 4px;
    }
    &-item {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 20px;
      widows: auto;
      height: 20px;
      border-radius: 5px;
      font-size: 12px;
      color: #005BAC;
      cursor: pointer;
      &.is-current {
        background-color: #005BAC;
        color: #fff;
      }
    }
    &-prev {
      font-size: 12px;
      color: #005BAC;
      cursor: pointer;
      margin-right: 24px;
      padding-right: 24px;
      border-right: 1px solid #DDDDDD;
    }
    &-next,
    &-end {
      font-size: 12px;
      color: #005BAC;
      cursor: pointer;
      margin-left: 24px;
      padding-left: 24px;
      border-left: 1px solid #DDDDDD;
    }
  }
  .document-detail {
    &-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 79px;
      padding: 0 16px 0 20px;
      border-bottom: 1px solid #DDDDDD;
    }
    &-caption {
      color: #005BAC;
      font-size: 12px;
    }
    &-menu {
      color: #005BAC;
      font-size: 12px;
      margin-left: 24px;
    }
    &-icon {
      width: 24px;
      height: 24px;
      color: $color-link;
      position: relative;
      margin-left: 25px;
      .tip {
        position: absolute;
        top: -20px;
        //margin-left: 4px;
        right: 0;
        //transform: translate3d(-50%,0,0);
        font-size: 1.4rem;
        font-weight: normal;
        white-space: nowrap;
        opacity: 0;
        transition: opacity .2s;
      }
      &:hover {
        -webkit-box-shadow: 0 5px 20px rgb(0 0 0 / 16%);
        box-shadow: 0 5px 20px rgb(0 0 0 / 16%);
        .tip {
          opacity: 1;
        }
      }
      .icn {
        width: 16px;
        height: 16px;
      }
    }
    &-body {
      @include bodyHeight(79px);
      padding: 20px;
      overflow-y: scroll;
      &-head {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
      }
      &-caption {
        padding: 4px 30px;
        border: 1px solid #E4E4E4;
        font-size: 12px;
        color: #333333;
        flex-shrink: 0;
        &-detail {
          font-size: 12px;
          // margin-left: 32px;
          color: #333333;
          flex-basis: calc(50% - 10px);
          min-width: calc(50% - 10px);
          flex-shrink: 0;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          width: 100%;
          strong{
            flex-basis: 62px;
            flex-shrink: 0;
            & + strong{
              flex-basis: 1em;
              flex-shrink: 0;
            }
          }
          &-wrap{
            margin-left: 32px;
            flex-basis: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: wrap;
            column-gap: 20px;
            row-gap: 8px;
          }
        }
      }
      &-section {
        margin-top: 24px;
      }
      &-title {
        display: block;
        width: 100%;
        position: relative;
        &::before {
          content: "";
          display: block;
          width: 14px;
          height: 1px;
          background-color: #005BAC;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          margin: auto;
          z-index: 2;
        }
        &::after {
          content: "";
          display: block;
          width: calc(100% - 14px);
          height: 1px;
          background-color: #DDDDDD;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          margin: auto;
          z-index: 2;
        }
        .text {
          display: inline-block;
          margin-left: 14px;
          padding: 0 20px 0 16px;
          color: #333333;
          background-color: #fff;
          position: relative;
          z-index: 3;
        }
      }
      &-text {
        margin-top: 20px;
        color: #555555;
        font-size: 14px;
        line-height: 1.714;
        img {
          max-width: 100%;
        }

        // 以下CD-ROM内包のcss
        .hen{line-height:150%;margin-left:6em;text-indent:-4em;}
        .syou{line-height:150%;margin-left:7em;text-indent:-4em;}
        .setu{line-height:150%;margin-left:8em;text-indent:-4em;}
        .kan{line-height:150%;margin-left:9em;text-indent:-4em;}
        .moku{line-height:150%;margin-left:10em;text-indent:-4em;}
        .jm{line-height:150%;margin-left:2em;text-indent:-1em;}
        .jd{line-height:150%;margin-left:1em;text-indent:-1em;}
        .jdt{line-height:150%;margin-left:6em;text-indent:-6em;}
        .fm{line-height:150%;margin-left:3em;text-indent:0em;}
        .chua{font-size:smaller;line-height:150%;margin-left:4em;text-indent:-4em;}
        .chub{font-size:smaller;line-height:150%;margin-left:3em;text-indent:-1em;}
        .sankou{font-size:smaller;line-height:150%;margin-left:4em;text-indent:-1em;}
        .sjoubun{font-size:smaller;line-height:150%;margin-left:4em;text-indent:-1em;}
        .enkaku{line-height:150%;font-size:smaller;margin-left:2em;text-indent:-1em;}
        .center{line-height:150%;text-align:center;}
        .right{line-height:150%;text-align:right;}
        .romanum{background-color:silver;}
        .marunum{background-color:silver;}
        .gaiji{background-color:silver;}
        .kizon{background-color:silver;}
        .strike{text-decoration:line-through}
        .ks{font-size:smaller;}
        A:link { color:blue;text-decoration:none;}
        A:visited { color:blue;Text-decoration:none;}
        A:active { color:#CC00CC;text-decoration:none;}
        A:hover { color:#FF0000;text-decoration:underline;}

        b{font-family:ＭＳ ゴシック, sans-seri;}
        .ind00{line-height:150%;margin-left:0em;text-indent:0em;}
        .ind01{line-height:150%;margin-left:0.5em;text-indent:-0.5em;}
        .ind02{line-height:150%;margin-left:1em;text-indent:-1em;}
        .ind03{line-height:150%;margin-left:1.5em;text-indent:-1.5em;}
        .ind04{line-height:150%;margin-left:2em;text-indent:-2em;}
        .ind05{line-height:150%;margin-left:2.5em;text-indent:-2.5em;}
        .ind06{line-height:150%;margin-left:3em;text-indent:-3em;}
        .ind07{line-height:150%;margin-left:3.5em;text-indent:-3.5em;}
        .ind08{line-height:150%;margin-left:4em;text-indent:-4em;}
        .ind09{line-height:150%;margin-left:4.5em;text-indent:-4.5em;}
        .ind0a{line-height:150%;margin-left:5em;text-indent:-5em;}
        .ind0b{line-height:150%;margin-left:5.5em;text-indent:-5.5em;}
        .ind0c{line-height:150%;margin-left:6em;text-indent:-6em;}
        .ind0d{line-height:150%;margin-left:6.5em;text-indent:-6.5em;}
        .ind0e{line-height:150%;margin-left:7em;text-indent:-7em;}
        .ind0f{line-height:150%;margin-left:7.5em;text-indent:-7.5em;}
        .ind0g{line-height:150%;margin-left:8em;text-indent:-8em;}
        .ind0h{line-height:150%;margin-left:8.5em;text-indent:-8.5em;}
        .ind0i{line-height:150%;margin-left:9em;text-indent:-9em;}
        .ind0j{line-height:150%;margin-left:9.5em;text-indent:-9.5em;}
        .ind0k{line-height:150%;margin-left:10em;text-indent:-10em;}
        .ind0l{line-height:150%;margin-left:10.5em;text-indent:-10.5em;}
        .ind0m{line-height:150%;margin-left:11em;text-indent:-11em;}
        .ind0n{line-height:150%;margin-left:11.5em;text-indent:-11.5em;}
        .ind0o{line-height:150%;margin-left:12em;text-indent:-12em;}
        .ind0q{line-height:150%;margin-left:13em;text-indent:-13em;}
        .ind0p{line-height:150%;margin-left:12.5em;text-indent:-12.5em;}
        .ind0r{line-height:150%;margin-left:13.5em;text-indent:-13.5em;}
        .ind0s{line-height:150%;margin-left:14em;text-indent:-14em;}
        .ind0t{line-height:150%;margin-left:14.5em;text-indent:-14.5em;}
        .ind0u{line-height:150%;margin-left:15em;text-indent:-15em;}
        .ind0v{line-height:150%;margin-left:15.5em;text-indent:-15.5em;}
        .ind0w{line-height:150%;margin-left:16em;text-indent:-16em;}
        .ind0x{line-height:150%;margin-left:16.5em;text-indent:-16.5em;}
        .ind0y{line-height:150%;margin-left:17em;text-indent:-17em;}

        .ind10{line-height:150%;margin-left:0em;text-indent:0.5em;}
        .ind11{line-height:150%;margin-left:0.5em;text-indent:0em;}
        .ind12{line-height:150%;margin-left:1em;text-indent:-0.5em;}
        .ind13{line-height:150%;margin-left:1.5em;text-indent:-1em;}
        .ind14{line-height:150%;margin-left:2em;text-indent:-1.5em;}
        .ind15{line-height:150%;margin-left:2.5em;text-indent:-2em;}
        .ind16{line-height:150%;margin-left:3em;text-indent:-2.5em;}
        .ind17{line-height:150%;margin-left:3.5em;text-indent:-3em;}
        .ind18{line-height:150%;margin-left:4em;text-indent:-3.5em;}
        .ind19{line-height:150%;margin-left:4.5em;text-indent:-4em;}
        .ind1b{line-height:150%;margin-left:5.5em;text-indent:-5em;}
        .ind1c{line-height:150%;margin-left:6em;text-indent:-5.5em;}
        .ind1e{line-height:150%;margin-left:7em;text-indent:-6.5em;}
        .ind1f{line-height:150%;margin-left:7.5em;text-indent:-7em;}
        .ind1g{line-height:150%;margin-left:8em;text-indent:-7.5em;}
        .ind1i{line-height:150%;margin-left:9em;text-indent:-8.5em;}
        .ind1k{line-height:150%;margin-left:10em;text-indent:-9.5em;}
        .ind1l{line-height:150%;margin-left:10.5em;text-indent:-10em;}
        .ind1m{line-height:150%;margin-left:11em;text-indent:-10.5em;}
        .ind1q{line-height:150%;margin-left:13em;text-indent:-12.5em;}

        .ind20{line-height:150%;margin-left:0em;text-indent:1em;}
        .ind22{line-height:150%;margin-left:1em;text-indent:0em;}
        .ind23{line-height:150%;margin-left:1.5em;text-indent:-0.5em;}
        .ind24{line-height:150%;margin-left:2em;text-indent:-1em;}
        .ind25{line-height:150%;margin-left:2.5em;text-indent:-1.5em;}
        .ind26{line-height:150%;margin-left:3em;text-indent:-2em;}
        .ind27{line-height:150%;margin-left:3.5em;text-indent:-2.5em;}
        .ind28{line-height:150%;margin-left:4em;text-indent:-3em;}
        .ind29{line-height:150%;margin-left:4.5em;text-indent:-3.5em;}
        .ind2a{line-height:150%;margin-left:5em;text-indent:-4em;}
        .ind2c{line-height:150%;margin-left:6em;text-indent:-5em;}
        .ind2d{line-height:150%;margin-left:6.5em;text-indent:-5.5em;}
        .ind2d{line-height:150%;margin-left:6.5em;text-indent:-5.5em;}
        .ind2e{line-height:150%;margin-left:7em;text-indent:-6em;}
        .ind2f{line-height:150%;margin-left:7.5em;text-indent:-6.5em;}
        .ind2g{line-height:150%;margin-left:8em;text-indent:-7em;}
        .ind2h{line-height:150%;margin-left:8.5em;text-indent:-7.5em;}
        .ind2h{line-height:150%;margin-left:8.5em;text-indent:-7.5em;}
        .ind2i{line-height:150%;margin-left:9em;text-indent:-8em;}
        .ind2j{line-height:150%;margin-left:9.5em;text-indent:-8.5em;}
        .ind2k{line-height:150%;margin-left:10em;text-indent:-9em;}
        .ind2l{line-height:150%;margin-left:10.5em;text-indent:-9.5em;}
        .ind2m{line-height:150%;margin-left:11em;text-indent:-10em;}
        .ind2n{line-height:150%;margin-left:11.5em;text-indent:-10.5em;}
        .ind2o{line-height:150%;margin-left:12em;text-indent:-11em;}
        .ind2p{line-height:150%;margin-left:12.5em;text-indent:-11.5em;}
        .ind2q{line-height:150%;margin-left:13em;text-indent:-12em;}
        .ind2r{line-height:150%;margin-left:13.5em;text-indent:-12.5em;}
        .ind2s{line-height:150%;margin-left:14em;text-indent:-13em;}
        .ind2t{line-height:150%;margin-left:14.5em;text-indent:-13.5em;}
        .ind2t{line-height:150%;margin-left:14.5em;text-indent:-13.5em;}
        .ind2u{line-height:150%;margin-left:15em;text-indent:-14em;}
        .ind2v{line-height:150%;margin-left:15.5em;text-indent:-14.5em;}
        .ind2w{line-height:150%;margin-left:16em;text-indent:-15em;}
        .ind2x{line-height:150%;margin-left:16.5em;text-indent:-15.5em;}

        .ind30{line-height:150%;margin-left:0em;text-indent:1.5em;}
        .ind32{line-height:150%;margin-left:1em;text-indent:0.5em;}
        .ind33{line-height:150%;margin-left:1.5em;text-indent:0em;}
        .ind34{line-height:150%;margin-left:2em;text-indent:-0.5em;}
        .ind35{line-height:150%;margin-left:2.5em;text-indent:-1em;}
        .ind36{line-height:150%;margin-left:3em;text-indent:-1.5em;}
        .ind37{line-height:150%;margin-left:3.5em;text-indent:-2em;}
        .ind38{line-height:150%;margin-left:4em;text-indent:-2.5em;}
        .ind39{line-height:150%;margin-left:4.5em;text-indent:-3em;}
        .ind3a{line-height:150%;margin-left:5em;text-indent:-3.5em;}
        .ind3b{line-height:150%;margin-left:5.5em;text-indent:-4em;}
        .ind3d{line-height:150%;margin-left:6.5em;text-indent:-5em;}
        .ind3e{line-height:150%;margin-left:7em;text-indent:-5.5em;}
        .ind3g{line-height:150%;margin-left:8em;text-indent:-6.5em;}
        .ind3h{line-height:150%;margin-left:8.5em;text-indent:-7em;}
        .ind3i{line-height:150%;margin-left:9em;text-indent:-7.5em;}
        .ind3k{line-height:150%;margin-left:10em;text-indent:-8.5em;}
        .ind3m{line-height:150%;margin-left:11em;text-indent:-9.5em;}
        .ind3q{line-height:150%;margin-left:13em;text-indent:-11.5em;}
        .ind3w{line-height:150%;margin-left:16em;text-indent:-14.5em;}
        .ind3y{line-height:150%;margin-left:17em;text-indent:-15.5em;}

        .ind40{line-height:150%;margin-left:0em;text-indent:2em;}
        .ind41{line-height:150%;margin-left:0.5em;text-indent:1.5em;}
        .ind42{line-height:150%;margin-left:1em;text-indent:1em;}
        .ind44{line-height:150%;margin-left:2em;text-indent:0em;}
        .ind45{line-height:150%;margin-left:2.5em;text-indent:-0.5em;}
        .ind46{line-height:150%;margin-left:3em;text-indent:-1em;}
        .ind47{line-height:150%;margin-left:3.5em;text-indent:-1.5em;}
        .ind48{line-height:150%;margin-left:4em;text-indent:-2em;}
        .ind49{line-height:150%;margin-left:4.5em;text-indent:-2.5em;}
        .ind4a{line-height:150%;margin-left:5em;text-indent:-3em;}
        .ind4b{line-height:150%;margin-left:5.5em;text-indent:-3.5em;}
        .ind4c{line-height:150%;margin-left:6em;text-indent:-4em;}
        .ind4d{line-height:150%;margin-left:6.5em;text-indent:-4.5em;}
        .ind4e{line-height:150%;margin-left:7em;text-indent:-5em;}
        .ind4f{line-height:150%;margin-left:7.5em;text-indent:-5.5em;}
        .ind4g{line-height:150%;margin-left:8em;text-indent:-6em;}
        .ind4h{line-height:150%;margin-left:8.5em;text-indent:-6.5em;}
        .ind4i{line-height:150%;margin-left:9em;text-indent:-7em;}
        .ind4j{line-height:150%;margin-left:9.5em;text-indent:-7.5em;}
        .ind4k{line-height:150%;margin-left:10em;text-indent:-8em;}
        .ind4l{line-height:150%;margin-left:10.5em;text-indent:-8.5em;}
        .ind4m{line-height:150%;margin-left:11em;text-indent:-9em;}
        .ind4o{line-height:150%;margin-left:12em;text-indent:-10em;}
        .ind4p{line-height:150%;margin-left:12.5em;text-indent:-10.5em;}
        .ind4q{line-height:150%;margin-left:13em;text-indent:-11em;}
        .ind4r{line-height:150%;margin-left:13.5em;text-indent:-11.5em;}
        .ind4s{line-height:150%;margin-left:14em;text-indent:-12em;}
        .ind4u{line-height:150%;margin-left:15em;text-indent:-13em;}
        .ind4v{line-height:150%;margin-left:15.5em;text-indent:-13.5em;}

        .ind50{line-height:150%;margin-left:0em;text-indent:2.5em;}
        .ind53{line-height:150%;margin-left:1.5em;text-indent:1em;}
        .ind54{line-height:150%;margin-left:2em;text-indent:0.5em;}
        .ind55{line-height:150%;margin-left:2.5em;text-indent:0em;}
        .ind56{line-height:150%;margin-left:3em;text-indent:-0.5em;}
        .ind57{line-height:150%;margin-left:3.5em;text-indent:-1em;}
        .ind58{line-height:150%;margin-left:4em;text-indent:-1.5em;}
        .ind59{line-height:150%;margin-left:4.5em;text-indent:-2em;}
        .ind5a{line-height:150%;margin-left:5em;text-indent:-2.5em;}
        .ind5b{line-height:150%;margin-left:5.5em;text-indent:-3em;}
        .ind5c{line-height:150%;margin-left:6em;text-indent:-3.5em;}
        .ind5d{line-height:150%;margin-left:6.5em;text-indent:-4em;}
        .ind5e{line-height:150%;margin-left:7em;text-indent:-4.5em;}
        .ind5f{line-height:150%;margin-left:7.5em;text-indent:-5em;}
        .ind5h{line-height:150%;margin-left:8.5em;text-indent:-6em;}
        .ind5j{line-height:150%;margin-left:9.5em;text-indent:-7em;}
        .ind5p{line-height:150%;margin-left:12.5em;text-indent:-10em;}
        .ind5v{line-height:150%;margin-left:15.5em;text-indent:-13em;}

        .ind60{line-height:150%;margin-left:0em;text-indent:3em;}
        .ind62{line-height:150%;margin-left:1em;text-indent:2em;}
        .ind64{line-height:150%;margin-left:2em;text-indent:1em;}
        .ind66{line-height:150%;margin-left:3em;text-indent:0em;}
        .ind67{line-height:150%;margin-left:3.5em;text-indent:-0.5em;}
        .ind68{line-height:150%;margin-left:4em;text-indent:-1em;}
        .ind69{line-height:150%;margin-left:4.5em;text-indent:-1.5em;}
        .ind6a{line-height:150%;margin-left:5em;text-indent:-2em;}
        .ind6b{line-height:150%;margin-left:5.5em;text-indent:-2.5em;}
        .ind6c{line-height:150%;margin-left:6em;text-indent:-3em;}
        .ind6d{line-height:150%;margin-left:6.5em;text-indent:-3.5em;}
        .ind6e{line-height:150%;margin-left:7em;text-indent:-4em;}
        .ind6f{line-height:150%;margin-left:7.5em;text-indent:-4.5em;}
        .ind6g{line-height:150%;margin-left:8em;text-indent:-5em;}
        .ind6h{line-height:150%;margin-left:8.5em;text-indent:-5.5em;}
        .ind6i{line-height:150%;margin-left:9em;text-indent:-6em;}
        .ind6i{line-height:150%;margin-left:9em;text-indent:-6em;}
        .ind6j{line-height:150%;margin-left:9.5em;text-indent:-6.5em;}
        .ind6k{line-height:150%;margin-left:10em;text-indent:-7em;}
        .ind6l{line-height:150%;margin-left:10.5em;text-indent:-7.5em;}
        .ind6m{line-height:150%;margin-left:11em;text-indent:-8em;}
        .ind6o{line-height:150%;margin-left:12em;text-indent:-9em;}
        .ind6q{line-height:150%;margin-left:13em;text-indent:-10em;}
        .ind6s{line-height:150%;margin-left:14em;text-indent:-11em;}
        .ind6u{line-height:150%;margin-left:15em;text-indent:-12em;}
        .ind6w{line-height:150%;margin-left:16em;text-indent:-13em;}
        .ind6x{line-height:150%;margin-left:16.5em;text-indent:-13.5em;}
        .ind6z{line-height:150%;margin-left:17.5em;text-indent:-14.5em;}

        .ind70{line-height:150%;margin-left:0em;text-indent:3.5em;}
        .ind74{line-height:150%;margin-left:2em;text-indent:1.5em;}
        .ind75{line-height:150%;margin-left:2.5em;text-indent:1em;}
        .ind76{line-height:150%;margin-left:3em;text-indent:0.5em;}
        .ind77{line-height:150%;margin-left:3.5em;text-indent:0em;}
        .ind78{line-height:150%;margin-left:4em;text-indent:-0.5em;}
        .ind79{line-height:150%;margin-left:4.5em;text-indent:-1em;}
        .ind7a{line-height:150%;margin-left:5em;text-indent:-1.5em;}
        .ind7b{line-height:150%;margin-left:5.5em;text-indent:-2em;}
        .ind7c{line-height:150%;margin-left:6em;text-indent:-2.5em;}
        .ind7d{line-height:150%;margin-left:6.5em;text-indent:-3em;}
        .ind7e{line-height:150%;margin-left:7em;text-indent:-3.5em;}
        .ind7f{line-height:150%;margin-left:7.5em;text-indent:-4em;}
        .ind7g{line-height:150%;margin-left:8em;text-indent:-4.5em;}
        .ind7h{line-height:150%;margin-left:8.5em;text-indent:-5em;}
        .ind7i{line-height:150%;margin-left:9em;text-indent:-5.5em;}
        .ind7j{line-height:150%;margin-left:9.5em;text-indent:-6em;}
        .ind7l{line-height:150%;margin-left:10.5em;text-indent:-7em;}

        .ind80{line-height:150%;margin-left:0em;text-indent:4em;}
        .ind82{line-height:150%;margin-left:1em;text-indent:3em;}
        .ind84{line-height:150%;margin-left:2em;text-indent:2em;}
        .ind85{line-height:150%;margin-left:2.5em;text-indent:1.5em;}
        .ind86{line-height:150%;margin-left:3em;text-indent:1em;}
        .ind87{line-height:150%;margin-left:3.5em;text-indent:0.5em;}
        .ind88{line-height:150%;margin-left:4em;text-indent:0em;}
        .ind89{line-height:150%;margin-left:4.5em;text-indent:-0.5em;}
        .ind8a{line-height:150%;margin-left:5em;text-indent:-1em;}
        .ind8b{line-height:150%;margin-left:5.5em;text-indent:-1.5em;}
        .ind8c{line-height:150%;margin-left:6em;text-indent:-2em;}
        .ind8d{line-height:150%;margin-left:6.5em;text-indent:-2.5em;}
        .ind8e{line-height:150%;margin-left:7em;text-indent:-3em;}
        .ind8f{line-height:150%;margin-left:7.5em;text-indent:-3.5em;}
        .ind8g{line-height:150%;margin-left:8em;text-indent:-4em;}
        .ind8h{line-height:150%;margin-left:8.5em;text-indent:-4.5em;}
        .ind8i{line-height:150%;margin-left:9em;text-indent:-5em;}
        .ind8j{line-height:150%;margin-left:9.5em;text-indent:-5.5em;}
        .ind8k{line-height:150%;margin-left:10em;text-indent:-6em;}
        .ind8l{line-height:150%;margin-left:10.5em;text-indent:-6.5em;}
        .ind8m{line-height:150%;margin-left:11em;text-indent:-7em;}
        .ind8n{line-height:150%;margin-left:11.5em;text-indent:-7.5em;}
        .ind8o{line-height:150%;margin-left:12em;text-indent:-8em;}
        .ind8p{line-height:150%;margin-left:12.5em;text-indent:-8.5em;}
        .ind8q{line-height:150%;margin-left:13em;text-indent:-9em;}
        .ind8r{line-height:150%;margin-left:13.5em;text-indent:-9.5em;}
        .ind8s{line-height:150%;margin-left:14em;text-indent:-10em;}
        .ind8t{line-height:150%;margin-left:14.5em;text-indent:-10.5em;}
        .ind8v{line-height:150%;margin-left:15.5em;text-indent:-11.5em;}

        .ind90{line-height:150%;margin-left:0em;text-indent:4.5em;}
        .ind97{line-height:150%;margin-left:3.5em;text-indent:1em;}
        .ind99{line-height:150%;margin-left:4.5em;text-indent:0em;}
        .ind9a{line-height:150%;margin-left:5em;text-indent:-0.5em;}
        .ind9b{line-height:150%;margin-left:5.5em;text-indent:-1em;}
        .ind9c{line-height:150%;margin-left:6em;text-indent:-1.5em;}
        .ind9c{line-height:150%;margin-left:6em;text-indent:-1.5em;}
        .ind9d{line-height:150%;margin-left:6.5em;text-indent:-2em;}
        .ind9e{line-height:150%;margin-left:7em;text-indent:-2.5em;}


        .inda0{line-height:150%;margin-left:0em;text-indent:5em;}
        .inda8{line-height:150%;margin-left:4em;text-indent:1em;}
        .indaa{line-height:150%;margin-left:5em;text-indent:0em;}
        .indab{line-height:150%;margin-left:5.5em;text-indent:-0.5em;}
        .indac{line-height:150%;margin-left:6em;text-indent:-1em;}
        .indad{line-height:150%;margin-left:6.5em;text-indent:-1.5em;}
        .indae{line-height:150%;margin-left:7em;text-indent:-2em;}
        .indaf{line-height:150%;margin-left:7.5em;text-indent:-2.5em;}
        .indag{line-height:150%;margin-left:8em;text-indent:-3em;}
        .indah{line-height:150%;margin-left:8.5em;text-indent:-3.5em;}
        .indai{line-height:150%;margin-left:9em;text-indent:-4em;}
        .indak{line-height:150%;margin-left:10em;text-indent:-5em;}
        .indam{line-height:150%;margin-left:11em;text-indent:-6em;}
        .indao{line-height:150%;margin-left:12em;text-indent:-7em;}
        .indaq{line-height:150%;margin-left:13em;text-indent:-8em;}
        .indar{line-height:150%;margin-left:13.5em;text-indent:-8.5em;}
        .indas{line-height:150%;margin-left:14em;text-indent:-9em;}
        .indau{line-height:150%;margin-left:15em;text-indent:-10em;}
        .indav{line-height:150%;margin-left:15.5em;text-indent:-10.5em;}
        .indaw{line-height:150%;margin-left:16em;text-indent:-11em;}
        .inday{line-height:150%;margin-left:17em;text-indent:-12em;}
        .indaz{line-height:150%;margin-left:17.5em;text-indent:-12.5em;}

        .indb9{line-height:150%;margin-left:4.5em;text-indent:1em;}
        .indba{line-height:150%;margin-left:5em;text-indent:0.5em;}
        .indbb{line-height:150%;margin-left:5.5em;text-indent:0em;}
        .indbc{line-height:150%;margin-left:6em;text-indent:-0.5em;}
        .indbd{line-height:150%;margin-left:6.5em;text-indent:-1em;}
        .indbe{line-height:150%;margin-left:7em;text-indent:-1.5em;}
        .indbf{line-height:150%;margin-left:7.5em;text-indent:-2em;}
        .indbi{line-height:150%;margin-left:9em;text-indent:-3.5em;}

        .indc0{line-height:150%;margin-left:0em;text-indent:6em;}
        .indc2{line-height:150%;margin-left:1em;text-indent:5em;}
        .indc8{line-height:150%;margin-left:4em;text-indent:2em;}
        .indca{line-height:150%;margin-left:5em;text-indent:1em;}
        .indcc{line-height:150%;margin-left:6em;text-indent:0em;}
        .indce{line-height:150%;margin-left:7em;text-indent:-1em;}
        .indcf{line-height:150%;margin-left:7.5em;text-indent:-1.5em;}
        .indcg{line-height:150%;margin-left:8em;text-indent:-2em;}
        .indch{line-height:150%;margin-left:8.5em;text-indent:-2.5em;}
        .indci{line-height:150%;margin-left:9em;text-indent:-3em;}
        .indck{line-height:150%;margin-left:10em;text-indent:-4em;}
        .indcm{line-height:150%;margin-left:11em;text-indent:-5em;}
        .indco{line-height:150%;margin-left:12em;text-indent:-6em;}
        .indcp{line-height:150%;margin-left:12.5em;text-indent:-6.5em;}
        .indcq{line-height:150%;margin-left:13em;text-indent:-7em;}
        .indcs{line-height:150%;margin-left:14em;text-indent:-8em;}
        .indct{line-height:150%;margin-left:14.5em;text-indent:-8.5em;}
        .indcu{line-height:150%;margin-left:15em;text-indent:-9em;}
        .indcw{line-height:150%;margin-left:16em;text-indent:-10em;}
        .indcy{line-height:150%;margin-left:17em;text-indent:-11em;}


        .inddb{line-height:150%;margin-left:5.5em;text-indent:1em;}
        .inddd{line-height:150%;margin-left:6.5em;text-indent:0em;}
        .indde{line-height:150%;margin-left:7em;text-indent:-0.5em;}
        .inddf{line-height:150%;margin-left:7.5em;text-indent:-1em;}
        .inddh{line-height:150%;margin-left:8.5em;text-indent:-2em;}


        .inde0{line-height:150%;margin-left:0em;text-indent:7em;}
        .inde6{line-height:150%;margin-left:3em;text-indent:4em;}
        .inde8{line-height:150%;margin-left:4em;text-indent:3em;}
        .indeb{line-height:150%;margin-left:5.5em;text-indent:1.5em;}
        .indec{line-height:150%;margin-left:6em;text-indent:1em;}
        .indee{line-height:150%;margin-left:7em;text-indent:0em;}
        .indef{line-height:150%;margin-left:7.5em;text-indent:-0.5em;}
        .indeg{line-height:150%;margin-left:8em;text-indent:-1em;}
        .indeh{line-height:150%;margin-left:8.5em;text-indent:-1.5em;}
        .indei{line-height:150%;margin-left:9em;text-indent:-2em;}
        .indek{line-height:150%;margin-left:10em;text-indent:-3em;}
        .indem{line-height:150%;margin-left:11em;text-indent:-4em;}
        .indeo{line-height:150%;margin-left:12em;text-indent:-5em;}
        .indep{line-height:150%;margin-left:12.5em;text-indent:-5.5em;}
        .indeq{line-height:150%;margin-left:13em;text-indent:-6em;}
        .inder{line-height:150%;margin-left:13.5em;text-indent:-6.5em;}
        .indes{line-height:150%;margin-left:14em;text-indent:-7em;}
        .indet{line-height:150%;margin-left:14.5em;text-indent:-7.5em;}
        .indeu{line-height:150%;margin-left:15em;text-indent:-8em;}
        .indew{line-height:150%;margin-left:16em;text-indent:-9em;}
        .index{line-height:150%;margin-left:16.5em;text-indent:-9.5em;}
        .indey{line-height:150%;margin-left:17em;text-indent:-10em;}
        .indez{line-height:150%;margin-left:17.5em;text-indent:-10.5em;}

        .indf0{line-height:150%;margin-left:0em;text-indent:7.5em;}
        .indfc{line-height:150%;margin-left:6em;text-indent:1.5em;}
        .indfd{line-height:150%;margin-left:6.5em;text-indent:1em;}
        .indfe{line-height:150%;margin-left:7em;text-indent:0.5em;}
        .indff{line-height:150%;margin-left:7.5em;text-indent:0em;}
        .indfg{line-height:150%;margin-left:8em;text-indent:-0.5em;}
        .indfh{line-height:150%;margin-left:8.5em;text-indent:-1em;}
        .indfi{line-height:150%;margin-left:9em;text-indent:-1.5em;}
        .indfk{line-height:150%;margin-left:10em;text-indent:-2.5em;}
        .indfl{line-height:150%;margin-left:10.5em;text-indent:-3em;}

        .indg8{line-height:150%;margin-left:4em;text-indent:4em;}
        .indge{line-height:150%;margin-left:7em;text-indent:1em;}
        .indgg{line-height:150%;margin-left:8em;text-indent:0em;}
        .indgh{line-height:150%;margin-left:8.5em;text-indent:-0.5em;}
        .indgi{line-height:150%;margin-left:9em;text-indent:-1em;}
        .indgk{line-height:150%;margin-left:10em;text-indent:-2em;}
        .indgm{line-height:150%;margin-left:11em;text-indent:-3em;}
        .indgo{line-height:150%;margin-left:12em;text-indent:-4em;}
        .indgp{line-height:150%;margin-left:12.5em;text-indent:-4.5em;}
        .indgq{line-height:150%;margin-left:13em;text-indent:-5em;}
        .indgs{line-height:150%;margin-left:14em;text-indent:-6em;}
        .indgt{line-height:150%;margin-left:14.5em;text-indent:-6.5em;}
        .indgu{line-height:150%;margin-left:15em;text-indent:-7em;}
        .indgv{line-height:150%;margin-left:15.5em;text-indent:-7.5em;}
        .indgo{line-height:150%;margin-left:12em;text-indent:-4em;}
        .indgj{line-height:150%;margin-left:9.5em;text-indent:-1.5em;}
        .indgw{line-height:150%;margin-left:16em;text-indent:-8em;}
        .indgy{line-height:150%;margin-left:17em;text-indent:-9em;}
        .indgn{line-height:150%;margin-left:11.5em;text-indent:-3.5em;}
        .indgz{line-height:150%;margin-left:17.5em;text-indent:-9.5em;}

        .indh0{line-height:150%;margin-left:0em;text-indent:8.5em;}
        .indhf{line-height:150%;margin-left:7.5em;text-indent:1em;}
        .indhh{line-height:150%;margin-left:8.5em;text-indent:0em;}
        .indhi{line-height:150%;margin-left:9em;text-indent:-0.5em;}
        .indhj{line-height:150%;margin-left:9.5em;text-indent:-1em;}
        .indhl{line-height:150%;margin-left:10.5em;text-indent:-2em;}
        .indhp{line-height:150%;margin-left:12.5em;text-indent:-4em;}

        .indih{line-height:150%;margin-left:8.5em;text-indent:0.5em;}
        .indi0{line-height:150%;margin-left:0em;text-indent:9em;}
        .indie{line-height:150%;margin-left:7em;text-indent:2em;}
        .indig{line-height:150%;margin-left:8em;text-indent:1em;}
        .indii{line-height:150%;margin-left:9em;text-indent:0em;}
        .indik{line-height:150%;margin-left:10em;text-indent:-1em;}
        .indil{line-height:150%;margin-left:10.5em;text-indent:-1.5em;}
        .indim{line-height:150%;margin-left:11em;text-indent:-2em;}
        .indio{line-height:150%;margin-left:12em;text-indent:-3em;}
        .indip{line-height:150%;margin-left:12.5em;text-indent:-3.5em;}
        .indiq{line-height:150%;margin-left:13em;text-indent:-4em;}
        .indir{line-height:150%;margin-left:13.5em;text-indent:-4.5em;}
        .indis{line-height:150%;margin-left:14em;text-indent:-5em;}
        .indit{line-height:150%;margin-left:14.5em;text-indent:-5.5em;}
        .indiu{line-height:150%;margin-left:15em;text-indent:-6em;}
        .indiv{line-height:150%;margin-left:15.5em;text-indent:-6.5em;}
        .indiw{line-height:150%;margin-left:16em;text-indent:-7em;}
        .indix{line-height:150%;margin-left:16.5em;text-indent:-7.5em;}
        .indiy{line-height:150%;margin-left:17em;text-indent:-8em;}
        .indiz{line-height:150%;margin-left:17.5em;text-indent:-8.5em;}


        .indjh{line-height:150%;margin-left:8.5em;text-indent:1em;}
        .indjj{line-height:150%;margin-left:9.5em;text-indent:0em;}
        .indjj{line-height:150%;margin-left:9.5em;text-indent:0em;}
        .indjk{line-height:150%;margin-left:10em;text-indent:-0.5em;}
        .indjl{line-height:150%;margin-left:10.5em;text-indent:-1em;}
        .indjn{line-height:150%;margin-left:11.5em;text-indent:-2em;}
        .indjq{line-height:150%;margin-left:13em;text-indent:-3.5em;}

        .indk0{line-height:150%;margin-left:0em;text-indent:10em;}
        .indki{line-height:150%;margin-left:9em;text-indent:1em;}
        .indkk{line-height:150%;margin-left:10em;text-indent:0em;}
        .indkm{line-height:150%;margin-left:11em;text-indent:-1em;}
        .indkn{line-height:150%;margin-left:11.5em;text-indent:-1.5em;}
        .indko{line-height:150%;margin-left:12em;text-indent:-2em;}
        .indkq{line-height:150%;margin-left:13em;text-indent:-3em;}
        .indkr{line-height:150%;margin-left:13.5em;text-indent:-3.5em;}
        .indks{line-height:150%;margin-left:14em;text-indent:-4em;}
        .indkt{line-height:150%;margin-left:14.5em;text-indent:-4.5em;}
        .indku{line-height:150%;margin-left:15em;text-indent:-5em;}
        .indkv{line-height:150%;margin-left:15.5em;text-indent:-5.5em;}
        .indkw{line-height:150%;margin-left:16em;text-indent:-6em;}
        .indkx{line-height:150%;margin-left:16.5em;text-indent:-6.5em;}
        .indky{line-height:150%;margin-left:17em;text-indent:-7em;}
        .indkz{line-height:150%;margin-left:17.5em;text-indent:-7.5em;}


        .indll{line-height:150%;margin-left:10.5em;text-indent:0em;}
        .indln{line-height:150%;margin-left:11.5em;text-indent:-1em;}
        .indlo{line-height:150%;margin-left:12em;text-indent:-1.5em;}
        .indlp{line-height:150%;margin-left:12.5em;text-indent:-2em;}
        .indlq{line-height:150%;margin-left:13em;text-indent:-2.5em;}
        .indlx{line-height:150%;margin-left:16.5em;text-indent:-6em;}

        .indm4{line-height:150%;margin-left:2em;text-indent:9em;}
        .indmk{line-height:150%;margin-left:10em;text-indent:1em;}
        .indmm{line-height:150%;margin-left:11em;text-indent:0em;}
        .indmo{line-height:150%;margin-left:12em;text-indent:-1em;}
        .indmp{line-height:150%;margin-left:12.5em;text-indent:-1.5em;}
        .indmq{line-height:150%;margin-left:13em;text-indent:-2em;}
        .indms{line-height:150%;margin-left:14em;text-indent:-3em;}
        .indmt{line-height:150%;margin-left:14.5em;text-indent:-3.5em;}
        .indmu{line-height:150%;margin-left:15em;text-indent:-4em;}
        .indmw{line-height:150%;margin-left:16em;text-indent:-5em;}
        .indmx{line-height:150%;margin-left:16.5em;text-indent:-5.5em;}
        .indmy{line-height:150%;margin-left:17em;text-indent:-6em;}


        .indnl{line-height:150%;margin-left:10.5em;text-indent:1em;}
        .indnn{line-height:150%;margin-left:11.5em;text-indent:0em;}
        .indnp{line-height:150%;margin-left:12.5em;text-indent:-1em;}
        .indns{line-height:150%;margin-left:14em;text-indent:-2.5em;}


        .indo0{line-height:150%;margin-left:0em;text-indent:12em;}
        .indo4{line-height:150%;margin-left:2em;text-indent:10em;}
        .indoo{line-height:150%;margin-left:12em;text-indent:0em;}
        .indoq{line-height:150%;margin-left:13em;text-indent:-1em;}
        .indor{line-height:150%;margin-left:13.5em;text-indent:-1.5em;}
        .indos{line-height:150%;margin-left:14em;text-indent:-2em;}
        .indoy{line-height:150%;margin-left:17em;text-indent:-5em;}
        .indow{line-height:150%;margin-left:16em;text-indent:-4em;}
        .indom{line-height:150%;margin-left:11em;text-indent:1em;}
        .indov{line-height:150%;margin-left:15.5em;text-indent:-3.5em;}
        .indou{line-height:150%;margin-left:15em;text-indent:-3em;}


        .indpn{line-height:150%;margin-left:11.5em;text-indent:1em;}
        .indpp{line-height:150%;margin-left:12.5em;text-indent:0em;}
        .indpr{line-height:150%;margin-left:13.5em;text-indent:-1em;}
        .indps{line-height:150%;margin-left:14em;text-indent:-1.5em;}


        .indqo{line-height:150%;margin-left:12em;text-indent:1em;}
        .indqq{line-height:150%;margin-left:13em;text-indent:0em;}
        .indqs{line-height:150%;margin-left:14em;text-indent:-1em;}
        .indqt{line-height:150%;margin-left:14.5em;text-indent:-1.5em;}
        .indqu{line-height:150%;margin-left:15em;text-indent:-2em;}
        .indqy{line-height:150%;margin-left:17em;text-indent:-4em;}
        .indqq{line-height:150%;margin-left:13em;text-indent:0em;}
        .indqv{line-height:150%;margin-left:15.5em;text-indent:-2.5em;}
        .indqw{line-height:150%;margin-left:16em;text-indent:-3em;}

        .indrr{line-height:150%;margin-left:13.5em;text-indent:0em;}
        .indrt{line-height:150%;margin-left:14.5em;text-indent:-1em;}


        .inds0{line-height:150%;margin-left:0em;text-indent:14em;}
        .indse{line-height:150%;margin-left:7em;text-indent:7em;}
        .indsq{line-height:150%;margin-left:13em;text-indent:1em;}
        .indss{line-height:150%;margin-left:14em;text-indent:0em;}
        .indsu{line-height:150%;margin-left:15em;text-indent:-1em;}
        .indsw{line-height:150%;margin-left:16em;text-indent:-2em;}
        .indsz{line-height:150%;margin-left:17.5em;text-indent:-3.5em;}

        .indtt{line-height:150%;margin-left:14.5em;text-indent:0em;}

        .induq{line-height:150%;margin-left:13em;text-indent:2em;}
        .induu{line-height:150%;margin-left:15em;text-indent:0em;}
        .induk{line-height:150%;margin-left:10em;text-indent:5em;}

        .indvv{line-height:150%;margin-left:15.5em;text-indent:0em;}

        .indw0{line-height:150%;margin-left:0em;text-indent:16em;}
        .indw4{line-height:150%;margin-left:2em;text-indent:14em;}
        .indww{line-height:150%;margin-left:16em;text-indent:0em;}
        .indwy{line-height:150%;margin-left:17em;text-indent:-1em;}


        .indxx{line-height:150%;margin-left:16.5em;text-indent:0em;}

        .indyy{line-height:150%;margin-left:17em;text-indent:0em;}

        .indz2{line-height:150%;margin-left:1em;text-indent:16.5em;}
        .indzz{line-height:150%;margin-left:17.5em;text-indent:0em;}
        .indv0{line-height:150%;margin-left:0em;text-indent:15.5em;}
      }
    }
  }

  // PC
  .pc{
    .document-lists-title{
      & + div{
        & > .document-lists-accordion-item{
          text-indent: -2em;
        }
      }
    }
    .document-formbox{
      .formparts{
        &.select{
          .select-label{
            border: 4px solid #F0F0F0;
            outline: 1px solid #DDDDDD;
            outline-offset: -4px;
            background-color: #fff;
            .icn{
              color: #707070;
            }
          }
          .select-option{
            padding-top: 0;
            &-list{
              transform: translateY(10px);
            }
          }
        }
      }
    }
  }

  // SP
  .sp{
    .main-container{
      min-height: calc(100vh - 64px);
    }
    .document-formbox-content + .formparts {
      margin-top: 16px;
    }
    .document-formbox{
      &.small {
        max-width: 168px;
      }
      .formparts{
        &.select{
          .select-label{
            border: 4px solid #F0F0F0;
            outline: 1px solid #DDDDDD;
            outline-offset: -4px;
            background-color: #fff;
            .icn{
              color: #707070;
            }
          }
          .select-option{
            padding-top: 0;
            &-list{
              transform: translateY(10px);
            }
          }
        }
      }
      &.calendar{
        .document-formbox-dateinput{
          max-width: calc(50% - 10px);
          input[type=text] {
            width: 100%;
          }
        }
      }
      &.num {
        .document-formbox-content {
          &.wrap{
            flex-wrap: wrap;
          }
          .formparts.select {
            flex-basis: 100px;
            .select-label {
              font-size: 12px;
              padding: 8px 20px 8px 12px;
              .icn {
                right: 10px;
              }
            }
            .select-option {
              .select-option-list {
                li {
                  font-size: 12px;
                  padding: 8px;
                }
              }
            }
            &.full{
              flex-basis: 100%;
              & + span{
                display: none;
                & + .formparts.text {
                  margin-left: 0;
                }
              }
            }
          }
          .formparts.text {
            &.long {
              flex-basis: 60px;
              input {
                font-size: 12px;
                padding-left: 4px;
                padding-right: 4px;
              }
            }
            &.short {
              flex-basis: 40px;
              input {
                font-size: 12px;
                padding-left: 4px;
                padding-right: 4px;
              }
            }
            &.full {
              flex-basis: calc(100% - 100px);
            }
          }
          span {
            font-size: 10px;
          }
        }
      }
    }
    .document-lists {
      &-title {
        padding: 28px 36px 24px;
        font-size: 20px;
        font-weight: bold;
        position: relative;
        &::after {
          content: "";
          display: block;
          width: calc(100% - 24px);
          height: 1px;
          background-color: #DDDDDD;
          position: absolute;
          bottom: 0;
          left: 12px;
        }
      }
      &-accordion {
        margin-top: 24px;
        padding: 0 24px 0 32px;
        & + & {
          margin-top: 8px;
        }
        .document-lists-accordion {
          padding: 0 0 0 1em;
        }
        &-head {
          color: #707070;
        }
        &-item {
          font-weight: bold;
          padding-right: 1em;
        }
      }
    }
    // .document-search {
    //   &-body {
    //     padding-left: 40px;
    //     padding-right: 40px;
    //   }
    // }
    .document-result {
      &-title {
        font-size: 20px;
        color: #000;
        font-weight: bold;
        span {
          font-size: 14px;
        }
        small {
          font-weight: normal;
        }
      }
      &-body-wrap{
        max-height: calc(100vh - 140px);
        overflow-y: auto;
      }
      &-column {
        justify-content: flex-start;
        .document-result-title {
          display: flex;
          align-items: center;
          width: 60px;
        }
      }
      &-buttons {
        width: calc(100% - 60px);
        button {
          // &:nth-of-type(2) {
          //   margin-left: auto;
          // }
          padding: 0;
          font-size: 14px;
          font-size: 12px;
          & + button {
            margin-left: 16px;
            padding-left: 16px;
            
            &::before {
              height: 100%;
            }
          }
        }
      }
    }
    .document-detail {
      &-head {
        display: none;
      }
      &-body {
        height: auto;
        padding: 24px 38px;
        max-height: calc(100vh - 65px);
        overflow-y: auto;
        &-caption {
          padding: 6px 20px;
        }
        &-date {
          margin-left: 10px;
        }
        &-num {
          margin-left: 20px;
        }
        &-title {
          &::before {
            width: 20px;
          }
          .text {
            padding: 0 14px 0 10px;
            font-size: 12px;
            font-weight: bold;
          }
        }
        &-text {
          margin-top: 16px;
        }
        &-head{
          .document-detail-body-caption-detail-wrap{
            flex-direction: column;
          }
        }
      }
    }
    .document-pager {
      //max-width: 340px;
      padding: 16px 45px 90px;
      background-color: #F9F8F6;
      &-prev,
      &-next {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 48px;
        margin: 0;
        padding: 0;
        background-color: #fff;
        border: 1px solid #DDDDDD;
      }
      &-prev {
        border-right: none;
        border-radius: 5px 0 0 5px;
        & + .document-pager-prev {
          border-radius: 0;
        }
      }
      &-next {
        border-left: none;
        & + .document-pager-next {
          border-radius: 0 5px 5px 0;
        }
      }
      .formparts.select {
        width: 220px;
        background-color: #fff;
        .select-label {
          border-radius: 0;
          color: #005BAC;
        }
        .select-option {
          position: absolute;
          top: 0;
          width: 100%;
          transform: none;
        }
        .select-option-list {
          position: absolute;
          top: 0;
          transform: translateY(calc(-100% - 10px));
        }
      }
      &.is-first {
        .formparts.select {
          .select-label {
            border-radius: 5px 0 0 5px;
          }
        }
      }
      &.is-end {
        .formparts.select {
          .select-label {
            border-radius: 0 5px 5px 0;
          }
        }
      }
    }
    .document-search {
      &-formparts {
        &-item {
          gap: 16px;
          margin: 0 !important;
          flex-shrink: 0;
          width: 100%;
          flex-wrap: wrap;
          & > * + * {
            margin: 0 !important;
          }
          & + .document-search-formparts-item {
            margin-top: 24px !important;
          }
        }
      }
    }
  }
</style>
